/**
 * AssetSettingsService
 * Asset Management module settings (key/value) + per-type notification channel toggles.
 */
import { CrudService } from '../base/CrudService';
/** Service for asset settings (getAll inherited) + per-name update + channel toggles. */
export class AssetSettingsService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetSettingsService.DEFAULT_SERVICE_PATH,
            basePath: AssetSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Update one setting by name. */
    async updateSetting(name, body) {
        const response = await this.updateSettingRaw(name, body);
        if (!response.data)
            throw new Error(`Failed to update setting '${name}'`);
        return response.data;
    }
    updateSettingRaw(name, body) {
        return this.http.put(this.buildUrl(encodeURIComponent(name)), body);
    }
    /** All notification-channel toggle rows. */
    async getChannels() {
        const response = await this.getChannelsRaw();
        return response.data ?? [];
    }
    getChannelsRaw() {
        return this.http.get(this.buildUrl('channels'));
    }
    /** Update one notification channel's toggles/template/priority. */
    async updateChannel(notificationTypeId, body) {
        const response = await this.updateChannelRaw(notificationTypeId, body);
        if (!response.data)
            throw new Error(`Failed to update channel ${notificationTypeId}`);
        return response.data;
    }
    updateChannelRaw(notificationTypeId, body) {
        return this.http.put(this.buildUrl(`channels/${notificationTypeId}`), body);
    }
}
AssetSettingsService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetSettingsService.BASE_PATH = 'api/asset-settings';
//# sourceMappingURL=AssetSettingsService.js.map